module.exports = __webpack_public_path__ + "img/peace_ios_802.png";